// A sentinel rather than '', which MUI reads as "nothing selected" and renders blank.
export const NO_BUCKET = 'NO_BUCKET';
